import React from 'react'
import PropTypes from 'prop-types'

import { Button, Page } from '@fielded/shared-ui'
import { hasFeature } from '../../../van-shared/utils/features'
import withConfig from '../../../van-shared/hoc/withConfig'
import { withUser } from '../../../common/AuthenticationProvider'

/**
 * Check if the current date is before the entry cutoff date for a given program.
 * @param {Object} program - The program object containing the report definition.
 * @returns {boolean} - Returns true if the current date is before the entry cutoff date, false otherwise.
 */
const insideCutoffOffset = (currentPeriod) => {
  const now = new Date()
  return now <= currentPeriod.entryCutOffDate
}

const Footer = ({onClickSave, onClickSubmit, loading, disabled, config, user, period}) => {
  const isFacilityUser = user.location.level === 'sdp'

  const mustShowSaveButton = hasFeature(config.features, 'stockReportingSave') &&
                             isFacilityUser &&
                             insideCutoffOffset(period)

  return (
    <Page.Footer>
      {!mustShowSaveButton && (
        <Button
          fill='outline'
          colorVariant='brand'
          size='large'
          onClick={onClickSubmit}
          id='footerSubmitBtn'
          className='submit-with-hint'
          loading={loading}
          disabled={disabled}
        >
        Submit stock count
        </Button>
      )}
      {mustShowSaveButton && (
        <Button
          fill='outline'
          colorVariant='brand'
          size='large'
          onClick={onClickSave}
          id='footerSaveBtn'
          className='submit-with-hint'
          loading={loading}
          disabled={disabled}
        >
          Save
        </Button>
      )}
    </Page.Footer>
  )
}

Footer.propTypes = {
  onClickSubmit: PropTypes.func.isRequired
}

export default withUser(withConfig(Footer))
